// extracted by mini-css-extract-plugin
export default {"container":"loader_container__XqHeU","top-cards-container-loader":"loader_top-cards-container-loader__dUrop","loaderWrap":"loader_loaderWrap__RNLsa"};